/**
 * Контракты комплектовочной ведомости (E13, ФТ-11.1–11.3).
 * Формат разбора — внутренний шаблон ПОТОК до закрытия Q3 (AN).
 */

import { z } from "zod";
import { decimalStringSchema } from "./catalog";
import { apiSuccessSchema } from "./envelope";

export const bomVersionStatusSchema = z.enum(["draft", "published", "archived"]);
export type BomVersionStatus = z.infer<typeof bomVersionStatusSchema>;

export const bomWeightSourceSchema = z.enum(["unit", "total"]);
export type BomWeightSource = z.infer<typeof bomWeightSourceSchema>;

export const bomMappingStatusSchema = z.enum(["requires_mapping", "mapped"]);
export type BomMappingStatus = z.infer<typeof bomMappingStatusSchema>;

export const bomVersionSchema = z.object({
  id: z.string().uuid(),
  conveyorUnitId: z.string().uuid(),
  versionNo: z.number().int().positive(),
  status: bomVersionStatusSchema,
  totalWeightKg: decimalStringSchema.nullable(),
  originalName: z.string().min(1),
  uploadedAt: z.string().datetime(),
  itemCount: z.number().int().nonnegative(),
  mappedCount: z.number().int().nonnegative(),
});
export type BomVersion = z.infer<typeof bomVersionSchema>;

export const bomItemSchema = z.object({
  id: z.string().uuid(),
  bomVersionId: z.string().uuid(),
  section: z.string().min(1),
  componentId: z.string().uuid().nullable(),
  componentCode: z.string().nullable(),
  name: z.string().nullable(),
  qty: decimalStringSchema,
  unitWeightKg: decimalStringSchema.nullable(),
  totalWeightKg: decimalStringSchema.nullable(),
  weightSource: bomWeightSourceSchema.nullable(),
  mappingStatus: bomMappingStatusSchema,
});
export type BomItem = z.infer<typeof bomItemSchema>;

export const bomVersionListResponseSchema = apiSuccessSchema(z.array(bomVersionSchema));
export const bomVersionResponseSchema = apiSuccessSchema(bomVersionSchema);
export const bomItemListResponseSchema = apiSuccessSchema(z.array(bomItemSchema));
export const bomItemResponseSchema = apiSuccessSchema(bomItemSchema);

/** Ручное сопоставление позиции с компонентом каталога (ФТ-11.1). */
export const mapBomItemRequestSchema = z.object({
  componentId: z.string().uuid(),
});
export type MapBomItemRequest = z.infer<typeof mapBomItemRequestSchema>;

export const BOM_ERROR_CODES = {
  UNIT_NOT_FOUND: "BOM_UNIT_NOT_FOUND",
  VERSION_NOT_FOUND: "BOM_VERSION_NOT_FOUND",
  ITEM_NOT_FOUND: "BOM_ITEM_NOT_FOUND",
  COMPONENT_NOT_FOUND: "BOM_COMPONENT_NOT_FOUND",
  FILE_REQUIRED: "BOM_FILE_REQUIRED",
  INVALID_FILE: "BOM_INVALID_FILE",
  PARSE_FAILED: "BOM_PARSE_FAILED",
  FILE_MISSING: "BOM_FILE_MISSING",
  NOT_DRAFT: "BOM_NOT_DRAFT",
} as const;
export type BomErrorCode = (typeof BOM_ERROR_CODES)[keyof typeof BOM_ERROR_CODES];
